export enum ProductInteractionType {
  Scan = "Scan",
  View = "View",
  AddToCollection = "AddToCollection",
}

export enum ProductInteractionPlatform {
  Web = 'Web',
  WebIos = 'WebIos',
  WebAndroid = 'WebAndroid',
  WebMobile = 'WebMobile',
  IOS = 'IOS',
  Android = 'Android',
  Unknown = 'Unknown',
}

export interface ProductInteraction {
  id: number
  created_at: string
  type: ProductInteractionType
  product: {
    name: string
  }
  user: {
    id: string
    email: string
  }
  account: {
    id: string
    name: string
  }
  collection?: {
    collection_type: string
  }
}

const getCurrentProductInteractionPlatform = () => {
  const ua = navigator.userAgent

  if (ua.includes('iPhone') || ua.includes('iPad')) {
    return ProductInteractionPlatform.WebIos
  } else if (ua.includes('Android')) {
    return ProductInteractionPlatform.WebAndroid
  } else if (screen.width <= 768 || screen.height <= 768) {
    return ProductInteractionPlatform.WebMobile
  } else {
    return ProductInteractionPlatform.Web
  }
}

export const currentProductInteractionPlatform = getCurrentProductInteractionPlatform()
